import React from "react";
import ReactResizeDetector from "react-resize-detector";
export default function PageWidthResizeDetector(props) {
    return React.createElement(ReactResizeDetector, { handleWidth: true, querySelector: "#content", onResize: props.onChanged });
}
